// extracted by mini-css-extract-plugin
export var lg = "_z-4";
export var md = "_z-3";
export var sm = "_z-2";
export var xs = "_z-1";
export var xxs = "_z-0";